module.exports = __webpack_public_path__ + "img/iphone.41a72b0c.png";